"use client";

import Text from "@/components/animations/Text";
import MotionHighlight from "@/components/effects/MotionHighlight";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselCounterProps } from "../types";
import CarouselFirst from "./carousel-first";
import CarouselLast from "./carousel-last";
import CarouselNext from "./carousel-next";
import CarouselPrevious from "./carousel-previous";
import { useCarouselStore } from "./carousel-provider";

function CarouselCounter({ className, ...props }: CarouselCounterProps) {
  const selectedSlide = useCarouselStore(store => store.selectedSlide);
  const totalSlides = useCarouselStore(store => store.totalSlides);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <MotionHighlight hover controlledItems className="rounded-sm bg-accent">
      <output
        className={cn(
          "flex flex-row justify-center items-center ~gap-2/8 flex-nowrap",
          className,
          classes,
        )}
        aria-live="polite"
        aria-atomic="true"
        {...native}
      >
        <MotionHighlight.Item>
          <CarouselFirst aria-label="First slide" variant="ghost" />
        </MotionHighlight.Item>

        <MotionHighlight.Item>
          <CarouselPrevious aria-label="Previous slide" variant="ghost" />
        </MotionHighlight.Item>

        <Flex.Row fill justify="center" items="center" className="text-center">
          <Text.SlidingNumber number={selectedSlide + 1} /> / {totalSlides}
        </Flex.Row>

        <MotionHighlight.Item>
          <CarouselNext aria-label="Next slide" variant="ghost" />
        </MotionHighlight.Item>

        <MotionHighlight.Item>
          <CarouselLast aria-label="Last slide" variant="ghost" />
        </MotionHighlight.Item>
      </output>
    </MotionHighlight>
  );
}

export default CarouselCounter;
